export class CmpSchoolObject {
    id = 0;
    name = '';
    abbreviation = '';
    address = '';
    city = '';
    stateCode = '';
    zip = '';
    country = '';
    status = false;
    type = '';
    isSelectedByApplicant = false;
    createdBy = 0;
}

export class CmpSchoolMiniObject {
    id = 0;
    name = '';
    abbreviation = '';
    city = '';
    stateCode = '';
    miniText = '';
    miniText2 = '';
    miniText3 = '';
}

export class CmpFauxDropdownOptionsObject {
    schools: Array<CmpSchoolMiniObject> = [];
    noResultText = '';
    customInputText = '';
    showCustom = '';
    showCustomInput = '';
    label = '';
    defaultCustomInputText = '';
    disableSearchDropdown = false;
    disableClearButton = false;
    clearInput = false;
    isInvalid = false;
    disableValidation = false;
}

export class CmpStaffingSeasonObject {
    staffingSeasonId = 0;
    staffingSeasonName = '';
}

export class CmpStaffApplicationTypeObject {
    id = 0;
    name = '';
    description = '';
    schoolSelection = '';
    schoolSelectionPlaceholder = '';
    qualifyCondition = ''
    submitted = false;
    confirmationPrompt = '';
}